import React from 'react';

interface DownArrowIconProps {
    height?: number;
    width?: number;
    color?: string;
}

const DownArrowIcon = ({ height = 24, width = 24, color = "black" }: DownArrowIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.06 16.06C12.7788 16.3409 12.3975 16.4987 12 16.4987C11.6025 16.4987 11.2213 16.3409 10.94 16.06L5.28202 10.404C5.00076 10.1226 4.8428 9.74102 4.8429 9.34316C4.84299 8.9453 5.00113 8.56377 5.28252 8.28251C5.56392 8.00125 5.94552 7.84329 6.34338 7.84338C6.74123 7.84348 7.12276 8.00162 7.40402 8.28301L12 12.879L16.596 8.28301C16.8788 8.00964 17.2576 7.85827 17.6509 7.8615C18.0442 7.86473 18.4205 8.0223 18.6988 8.30028C18.977 8.57827 19.1349 8.95441 19.1385 9.34771C19.1421 9.741 18.9911 10.12 18.718 10.403L13.061 16.061L13.06 16.06Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default DownArrowIcon;
